var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarDisable = function SvgCalendarDisable(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:currentColor;stroke-linejoin:round;stroke-width:1.5px;}.b{stroke-linecap:round;}")), /*#__PURE__*/React.createElement("title", null, "calendar-disable"), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 19.5,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.75,
    y1: 9.75,
    x2: 23.25,
    y2: 9.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.75,
    y1: 6,
    x2: 6.75,
    y2: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 17.25,
    y1: 6,
    x2: 17.25,
    y2: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9,
    y1: 13.5,
    x2: 15,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9,
    y1: 19.5,
    x2: 15,
    y2: 13.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarDisable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calendar-disable.c2308d24d670f6ba842c241d14838f29.svg";